import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LocalStorage } from './shared/functions/LocalStorage';

export enum SplitAreaState {
    None = 'None',
    Map = 'Map',
    IWI = 'IWI',
}

@Injectable()
export class SplitAreaService {
    @LocalStorage
    private splitAreaCache: SplitAreaState = SplitAreaState.None;

    public splitAreaState$: BehaviorSubject<SplitAreaState>;

    public isMapVisible: boolean = false;
    public isIwiVisible: boolean = false;

    constructor(
    ) {
        // restore state from cache
        const splitAreaState = this.splitAreaCache ?? SplitAreaState.None;

        this.splitAreaState$ = new BehaviorSubject<SplitAreaState>(splitAreaState);

        this.splitAreaState$.subscribe(res => {
            this.splitAreaCache = res;
            this.isMapVisible = res === SplitAreaState.Map;
            this.isIwiVisible = res === SplitAreaState.IWI;
        });
    }

    public toggleMapVisibility() {
        this.splitAreaState$.next(this.isMapVisible ? SplitAreaState.None : SplitAreaState.Map);
    }

    public toggleIwiVisibility() {
        this.splitAreaState$.next(this.isIwiVisible ? SplitAreaState.None : SplitAreaState.IWI);
    }
}
